<template>
  <div :class="$root.theme">
    <Header :locale="locale" />

    <Spinner v-if="loading" />
    <PayForm
      v-else
      :checkout-id="$route.params.checkoutId"
      :secrets="secrets"
      :locale="locale"
    />

    <Footer :locale="locale" />
  </div>
</template>

<script>
import PayForm from "./PayForm";
import { functions } from '@/firebase';
import Footer from "@/components/Footer";
import Spinner from "@/components/Spinner";
import Header from "@/components/Header";

export default {
  components: {
    Header,
    Spinner,
    Footer,
    PayForm,
  },
  props: {
    locale: { type: String, default: 'en' }
  },
  created() {
    this.$i18n.locale = this.locale;
  },
  data() {
    return {
      loading: true,
      secrets: null
    }
  },
  async mounted() {
    const response = await functions.httpsCallable('fetchConfig')();
    this.secrets = response.data;
    this.loading = false;
  },
}
</script>

<style lang="scss">
.enneagram {
  background-color: #E3DCC6;
}
</style>
